export default "__VITE_PUBLIC_ASSET__b32ecf40__"